module.exports = __webpack_public_path__ + "static/media/2.df4606ff.jpg";